/**
 * Close a dispatcher over a union with this, and forgetting a case becomes a compile error
 * — the argument only narrows to `never` once every case above it is answered.
 *
 * ```ts
 * if (command === 'pause' || command === 'run') return setPaused(item, command === 'pause')
 * return assertUnreachable(command)
 * ```
 *
 * The alternative — an `if` chain ending in a bare call — answers its last case *and* every
 * case nobody wrote, which is how a menu command nobody handled ends up running the
 * opposite action. At runtime this throws, so it also says so if a value arrives that the
 * types ruled out.
 */
export function assertUnreachable(value: never): never {
  throw new Error(`Unhandled case: ${String(value)}`)
}
